// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"843":"6c075f2f","852":"4d05abfd"}[chunkId] + ".chunk.js";
};